import { useEffect } from "react";
import { comnUtils } from "@/comn/utils";
import { Page, Group, Layout, Button } from "@/comn/components";
import { useForm, useFetch, useModal, usePage } from "@/comn/hooks";
import { URLS, APIS, SF_MSG_LANG } from "./services/MsgLangPrsccService";
import { useNavigate, useParams } from "react-router-dom";

export const MsgLangDtl = () => {
    const { pgeUid, menuId } = usePage({
        auth: ["auth_osci0003"],
    });
    const navigate = useNavigate(); // Navigate Hook !== 화면 이동 Hook ==!
    const modal = useModal(); // Modal Window Hook !== Modal 창 Hook ==!
    const { msgId } = useParams(); // Key Information of this Component Router !== 라우터에 정의된 키정보 ==!

    const form = {
        msgLang: useForm({
            defaultSchema: SF_MSG_LANG,
            defaultValues: {},
        }),
    };

    const fetch = {
        getMsgLang: useFetch({
            api: () => APIS.getMsgLang(msgId),
            enabled: !!msgId,
            onSuccess: (data) => {
                const msgLang = data.msgLang.content;
                const msgLangInfoList = msgLang.msgLangInfoList;

                if (msgLangInfoList) {
                    msgLangInfoList.map((item: any) => {
                        switch (item.langCd) {
                            case "EN":
                                msgLang.msgCnEn = item.msgCn;
                                break;
                            case "TZ":
                                msgLang.msgCnTz = item.msgCn;
                                break;
                            default:
                                msgLang.msgCnKo = item.msgCn;
                                break;
                        }
                    });
                }
                form.msgLang.setValues(msgLang);
            },
            onError: () => {},
            showToast: true,
        }),
        deleteMsgLang: useFetch({
            api: (msgIds) => APIS.deleteMsgLang(msgIds),
            onSuccess: () => {
                modal.openModal({
                    content: "msg.osc.00006",
                    onCancel: () => {
                        comnUtils.isEmpty(menuId) ? navigate(`${URLS.msgLangLst}`) : navigate(`${URLS.ptli1019001q}`);
                    },
                });
            },
            onError: () => {},
            showToast: true,
        }),
    };

    const handler = {
        deleteMsgLang: () => {
            modal.openModal({
                content: "msg.osc.00095",
                onConfirm: () => {
                    fetch.deleteMsgLang.fetch(msgId);
                },
            });
        },
    };

    useEffect(() => {
        fetch.getMsgLang.fetch();
        form.msgLang.setEditable(false);
    }, []);

    return (
        <Page {...(comnUtils.isEmpty(menuId) ? { pgeUid: pgeUid, info: true } : {})}>
            <form>
                <Group>
                    <Group.Body>
                        <Group.Section>
                            <Group.Row>
                                <Group.Control {...form.msgLang.schema.msgId}></Group.Control>
                            </Group.Row>
                            <Group.Row>
                                <Group.Control {...form.msgLang.schema.bsopClsfCd}></Group.Control>
                            </Group.Row>
                            <Group.Row>
                                <Group.Control {...form.msgLang.schema.msgCnEn}></Group.Control>
                            </Group.Row>
                            <Group.Row>
                                <Group.Control {...form.msgLang.schema.msgCnTz}></Group.Control>
                            </Group.Row>
                            <Group.Row>
                                <Group.Control {...form.msgLang.schema.msgCnKo}></Group.Control>
                            </Group.Row>
                            <Group.Row>
                                <Group.Control {...form.msgLang.schema.frstRegstId}></Group.Control>
                                <Group.Control {...form.msgLang.schema.frstRgsrDtm}></Group.Control>
                            </Group.Row>
                        </Group.Section>
                    </Group.Body>
                </Group>
            </form>
            <Layout direction="row">
                <Layout.Left>
                    <Button
                        role="list"
                        onClick={() => {
                            comnUtils.isEmpty(menuId)
                                ? navigate(`${URLS.msgLangLst}`)
                                : navigate(`${URLS.ptli1019001q}`);
                        }}
                    ></Button>
                </Layout.Left>
                <Layout.Right>
                    <Button
                        role="edit"
                        onClick={() => {
                            comnUtils.isEmpty(menuId)
                                ? navigate(`${URLS.msgLangEdit}/${msgId}`)
                                : navigate(`${URLS.ptli1019004s}/${msgId}`);
                        }}
                    ></Button>
                    <Button
                        role="delete"
                        onClick={() => {
                            handler.deleteMsgLang();
                        }}
                    ></Button>
                </Layout.Right>
            </Layout>
        </Page>
    );
};
